import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/ui-components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/ui-components/ui/tabs";
import { UserCircle, Users } from "lucide-react";
import { useState } from "react";
import { RankingTable } from "./ranking-table";

const RankingParent = () => {
  const [rankingType, setRankingType] = useState<"individual" | "team">("individual");

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <div className="space-y-1">
          <CardTitle>Rangliste</CardTitle>
          <CardDescription>Sortierung nach Verkäufen</CardDescription>
        </div>
        <Tabs
          defaultValue="individual"
          className="w-[200px]"
          onValueChange={(value) => setRankingType(value as "individual" | "team")}
        >
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="individual">
              <UserCircle className="mr-2 h-4 w-4 min-h-4 min-w-4" />
              Individual
            </TabsTrigger>
            <TabsTrigger value="team">
              <Users className="mr-2 h-4 w-4" />
              Team
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </CardHeader>
      <CardContent>
        <RankingTable type={rankingType} />
      </CardContent>
    </Card>
  );
};

export default RankingParent;
